import { render, staticRenderFns } from "./GameReplayView.vue?vue&type=template&id=15ade446&scoped=true"
import script from "./GameReplayView.vue?vue&type=script&lang=js"
export * from "./GameReplayView.vue?vue&type=script&lang=js"
import style0 from "./GameReplayView.vue?vue&type=style&index=0&id=15ade446&prod&lang=scss&scoped=true"
import style1 from "./GameReplayView.vue?vue&type=style&index=1&id=15ade446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ade446",
  null
  
)

export default component.exports